import request from '@/utils/request'

const loginApi = {
  Login: 'Passport/loginByPwd',
  sendSmsCaptcha: 'captcha/sendSmsCaptcha',
  loginWebByWx: 'passport/loginWebByWx',
  mobileLogin: 'Passport/login',
  loginByCode: 'idpAuth/loginByCode',
  logout: 'idpAuth/logout',
  searchCertList: 'User/searchCertList',
  getLogoByDomain: 'enterPrise/getLogoByDomain',
  getMiniQrCode: "https://rccp-api.huashuyunai.com/index.php?s=/api/user/getMiniQrCode"
}

export function getMiniQrCode(parameter) {
  return request({
    url: loginApi.getMiniQrCode,
    method: 'get',
    params: parameter
  })
}


export function getLogoByDomain(parameter) {
  return request({
    url: loginApi.getLogoByDomain,
    method: 'get',
    params: parameter
  })
}

export function searchCertList(parameter) {
  return request({
    url: loginApi.searchCertList,
    method: 'get',
    params: parameter
  })
}

export function logout (parameter) {
  return request({
    url: loginApi.logout,
    method: 'post',
    data: parameter
  })
}

export function loginByCode (parameter) {
  return request({
    url: loginApi.loginByCode,
    method: 'post',
    data: parameter
  })
}

export function mobileLogin (parameter) {
  return request({
    url: loginApi.mobileLogin,
    method: 'post',
    data: parameter
  })
}

export function loginWebByWx (parameter) {
  return request({
    url: loginApi.loginWebByWx,
    method: 'post',
    data: parameter
  })
}

/**
 * login func
 * parameter: {
 *     username: '',
 *     password: '',
 *     remember_me: true,
 *     captcha: '12345'
 * }
 * @param parameter
 * @returns {*}
 */
export function login (parameter) {
  return request({
    url: loginApi.Login,
    method: 'post',
    data: parameter
  })
}

export function sendSmsCaptcha (parameter) {
  return request({
    url: loginApi.sendSmsCaptcha,
    method: 'post',
    data: parameter
  })
}
